"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ViewsService", {
    enumerable: true,
    get: function() {
        return ViewsService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _helpers = require("~/helpers");
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _NocoSocket = /*#__PURE__*/ _interop_require_default(require("~/socket/NocoSocket"));
const _viewwebhookmanager = require("~/utils/view-webhook-manager");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
// todo: move
async function xcVisibilityMetaGet(context, param) {
    const { includeM2M = true, baseId, models: _models1 } = param != null ? param : {};
    // todo: move to
    const roles = [
        'owner',
        'creator',
        'viewer',
        'editor',
        'commenter',
        'guest'
    ];
    const defaultDisabled = roles.reduce((o, r)=>_extends({}, o, {
            [r]: false
        }), {});
    let models = _models1 || await _models.Model.list(context, {
        base_id: baseId,
        source_id: undefined
    });
    models = includeM2M ? models : models.filter((t)=>!t.mm);
    const result = await models.reduce(async (_obj, model)=>{
        const obj = await _obj;
        const views = await model.getViews(context);
        for (const view of views){
            obj[view.id] = _extends({
                ptn: model.table_name,
                _ptn: model.title,
                ptype: model.type,
                tn: view.title,
                _tn: view.title,
                table_meta: model.meta
            }, view, {
                disabled: _extends({}, defaultDisabled)
            });
        }
        return obj;
    }, Promise.resolve({}));
    const disabledList = await _models.ModelRoleVisibility.list(context, baseId);
    for (const d of disabledList){
        if (result[d.fk_view_id]) result[d.fk_view_id].disabled[d.role] = !!d.disabled;
    }
    return Object.values(result);
}
let ViewsService = class ViewsService {
    async viewList(context, param) {
        const model = await _models.Model.get(context, param.tableId);
        if (!model) {
            _catchError.NcError.get(context).tableNotFound(param.tableId);
        }
        const viewList = await xcVisibilityMetaGet(context, {
            baseId: model.base_id,
            models: [
                model
            ]
        });
        // todo: user roles
        //await View.list(param.tableId)
        const filteredViewList = viewList.filter((view)=>{
            // if (
            //   view.lock_type === ViewLockType.Personal &&
            //   view.owned_by !== param.user.id &&
            //   !(!view.owned_by && !param.user.base_roles?.[ProjectRoles.OWNER])
            // ) {
            //   return false;
            // }
            return Object.values(_nocodbsdk.ProjectRoles).some((role)=>{
                var _param_user_base_roles, _param_user;
                return (param == null ? void 0 : (_param_user = param.user) == null ? void 0 : (_param_user_base_roles = _param_user['base_roles']) == null ? void 0 : _param_user_base_roles[role]) && !view.disabled[role];
            });
        });
        return filteredViewList;
    }
    async shareView(context, param) {
        const res = await _models.View.share(context, param.viewId);
        const view = await _models.View.get(context, param.viewId);
        if (!view) {
            _catchError.NcError.get(context).viewNotFound(param.viewId);
        }
        this.appHooksService.emit(_nocodbsdk.AppEvents.SHARED_VIEW_CREATE, {
            user: param.user,
            view,
            req: param.req,
            context
        });
        return res;
    }
    async viewUpdate(context, param, ncMeta = _Noco.default.ncMeta) {
        var _param_viewWebhookManager;
        var _param_req_user;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/ViewUpdateReq', param.view);
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        const oldView = await _models.View.get(context, param.viewId, ncMeta);
        if (!oldView) {
            _catchError.NcError.get(context).viewNotFound(param.viewId);
        }
        if (param.view.title && param.view.title.trim() !== oldView.title) {
            var _param_view_title;
            param.view.title = (_param_view_title = param.view.title) == null ? void 0 : _param_view_title.trim();
            const existingView = await _models.View.getByTitleOrId(context, {
                titleOrId: param.view.title,
                fk_model_id: oldView.fk_model_id
            }, ncMeta);
            if (existingView) {
                _catchError.NcError.get(context).duplicateAlias({
                    type: 'view',
                    alias: param.view.title,
                    label: 'title',
                    base: context.base_id,
                    additionalTrace: {
                        table: oldView.fk_model_id
                    }
                });
            }
        }
        const viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(oldView.fk_model_id)).withViewId(param.viewId)).forUpdate();
        let ownedBy = oldView.owned_by;
        let createdBy = oldView.created_by;
        let includeCreatedByAndUpdateBy = false;
        // check if the lock_type changing to `personal` and only allow if user is the owner
        // if the owned_by is not the same as the user, then throw error
        // if owned_by is empty, then only allow owner of project to change
        if (param.view.lock_type === _nocodbsdk.ViewLockType.Personal && param.view.lock_type !== oldView.lock_type) {
            var _param_user_base_roles;
            // Check if this is the last collaborative grid view
            // Prevent changing to personal if this is the only non-personal grid view
            if (oldView.type === _nocodbsdk.ViewTypes.GRID) {
                const views = await _models.View.list(context, oldView.fk_model_id, ncMeta);
                const otherNonPersonalGridView = (0, _nocodbsdk.getFirstNonPersonalView)(views.filter((v)=>v.id !== oldView.id), {
                    includeViewType: _nocodbsdk.ViewTypes.GRID
                });
                if (!otherNonPersonalGridView) {
                    _catchError.NcError.get(context).badRequest('Cannot change the last collaborative grid view to personal');
                }
            }
            // if owned_by is not empty then check if the user is the owner of the project
            if (ownedBy && ownedBy !== param.user.id) {
                _catchError.NcError.get(context).unauthorized('Only owner/creator can change to personal view');
            }
            // if empty then check if current user is the owner of the project then allow and update the owned_by
            if (!ownedBy && ((_param_user_base_roles = param.user.base_roles) == null ? void 0 : _param_user_base_roles[_nocodbsdk.ProjectRoles.OWNER])) {
                includeCreatedByAndUpdateBy = true;
                ownedBy = param.user.id;
                if (!createdBy) {
                    createdBy = param.user.id;
                }
            } else if (!ownedBy) {
                // todo: move to catchError
                _catchError.NcError.get(context).unauthorized('Only owner can change to personal view');
            }
        }
        // handle view ownership transfer
        if (ownedBy && param.view.owned_by && ownedBy !== param.view.owned_by) {
            var _param_user_base_roles1, _param_user_base_roles2;
            // extract user roles and allow creator and owner to change to personal view
            if (param.user.id !== ownedBy && !((_param_user_base_roles1 = param.user.base_roles) == null ? void 0 : _param_user_base_roles1[_nocodbsdk.ProjectRoles.OWNER]) && !((_param_user_base_roles2 = param.user.base_roles) == null ? void 0 : _param_user_base_roles2[_nocodbsdk.ProjectRoles.CREATOR])) {
                _catchError.NcError.get(context).unauthorized('Only owner/creator can transfer view ownership');
            }
            ownedBy = param.view.owned_by;
            // verify if the new owned_by is a valid user who have access to the base/workspace
            // if not then throw error
            const baseUser = await _models.BaseUser.get(context, context.base_id, param.view.owned_by, ncMeta);
            if (!baseUser) {
                _catchError.NcError.get(context).badRequest('Invalid user');
            }
            includeCreatedByAndUpdateBy = true;
        }
        const result = await _models.View.update(context, param.viewId, _extends({}, param.view, {
            owned_by: ownedBy,
            created_by: createdBy
        }), includeCreatedByAndUpdateBy, ncMeta);
        let owner = param.req.user;
        if (ownedBy && ownedBy !== ((_param_req_user = param.req.user) == null ? void 0 : _param_req_user.id)) {
            owner = await _models.User.get(ownedBy, ncMeta);
        }
        this.appHooksService.emit(_nocodbsdk.AppEvents.VIEW_UPDATE, {
            view: _extends({}, oldView, param.view),
            oldView,
            user: param.user,
            req: param.req,
            context,
            owner
        });
        await result.getView(context, ncMeta);
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'view_update',
                payload: result
            }
        }, context.socket_id);
        if (!param.viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(oldView.id)).emit();
        }
        return result;
    }
    async viewDelete(context, param, ncMeta = _Noco.default.ncMeta) {
        var _param_req_user;
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        const view = await _models.View.get(context, param.viewId, ncMeta);
        if (!view) {
            _catchError.NcError.get(context).viewNotFound(param.viewId);
        }
        const views = await _models.View.list(context, view.fk_model_id, ncMeta);
        // Check if this is the last collaborative grid view
        // Use helper to find if there's at least one other non-personal grid view
        if (view.type === _nocodbsdk.ViewTypes.GRID && view.lock_type !== _nocodbsdk.ViewLockType.Personal) {
            const otherNonPersonalGridView = (0, _nocodbsdk.getFirstNonPersonalView)(views.filter((v)=>v.id !== view.id), {
                includeViewType: _nocodbsdk.ViewTypes.GRID
            });
            if (!otherNonPersonalGridView) {
                _catchError.NcError.get(context).badRequest('Cannot delete the last collaborative grid view');
            }
        }
        const viewWebhookManager = (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(view.id)).forDelete();
        await _models.View.delete(context, param.viewId, ncMeta);
        let deleteEvent = _nocodbsdk.AppEvents.GRID_DELETE;
        //  decide event based on type
        if (view.type === _nocodbsdk.ViewTypes.FORM) {
            deleteEvent = _nocodbsdk.AppEvents.FORM_DELETE;
        } else if (view.type === _nocodbsdk.ViewTypes.CALENDAR) {
            deleteEvent = _nocodbsdk.AppEvents.CALENDAR_DELETE;
        } else if (view.type === _nocodbsdk.ViewTypes.GALLERY) {
            deleteEvent = _nocodbsdk.AppEvents.GALLERY_DELETE;
        } else if (view.type === _nocodbsdk.ViewTypes.KANBAN) {
            deleteEvent = _nocodbsdk.AppEvents.KANBAN_DELETE;
        } else if (view.type === _nocodbsdk.ViewTypes.MAP) {
            deleteEvent = _nocodbsdk.AppEvents.MAP_DELETE;
        } else if (view.type === _nocodbsdk.ViewTypes.LIST) {
            deleteEvent = _nocodbsdk.AppEvents.LIST_DELETE;
        }
        let owner = param.req.user;
        if (view.owned_by && view.owned_by !== ((_param_req_user = param.req.user) == null ? void 0 : _param_req_user.id)) {
            owner = await _models.User.get(view.owned_by);
        }
        this.appHooksService.emit(deleteEvent, {
            view,
            user: param.user,
            owner,
            req: param.req,
            context
        });
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'view_delete',
                payload: view
            }
        }, context.socket_id);
        viewWebhookManager.emit();
        return true;
    }
    async shareViewUpdate(context, param) {
        var _ref;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/SharedViewReq', param.sharedView);
        const view = await _models.View.get(context, param.viewId);
        if (!view) {
            _catchError.NcError.get(context).viewNotFound(param.viewId);
        }
        let customUrl = await _models.CustomUrl.get({
            view_id: view.id,
            id: view.fk_custom_url_id
        });
        // Update an existing custom URL if it exists
        if (customUrl == null ? void 0 : customUrl.id) {
            const original_path = await _models.View.getSharedViewPath(context, view.id);
            if (param.sharedView.custom_url_path) {
                // Prepare updated fields conditionally
                const updates = {
                    original_path
                };
                if (param.sharedView.custom_url_path !== undefined) {
                    updates.custom_path = param.sharedView.custom_url_path;
                }
                // Perform the update if there are changes
                if (Object.keys(updates).length > 0) {
                    await _models.CustomUrl.update(view.fk_custom_url_id, updates);
                }
            } else if (param.sharedView.custom_url_path !== undefined) {
                // Delete the custom URL if only the custom path is undefined
                await _models.CustomUrl.delete({
                    id: view.fk_custom_url_id
                });
                customUrl = undefined;
            }
        } else if (param.sharedView.custom_url_path) {
            // Insert a new custom URL if it doesn't exist
            const original_path = await _models.View.getSharedViewPath(context, view.id);
            customUrl = await _models.CustomUrl.insert({
                fk_workspace_id: view.fk_workspace_id,
                base_id: view.base_id,
                fk_model_id: view.fk_model_id,
                view_id: view.id,
                original_path,
                custom_path: param.sharedView.custom_url_path
            });
        }
        const result = await _models.View.update(context, param.viewId, _extends({}, param.sharedView, {
            fk_custom_url_id: (_ref = customUrl == null ? void 0 : customUrl.id) != null ? _ref : null
        }));
        this.appHooksService.emit(_nocodbsdk.AppEvents.SHARED_VIEW_UPDATE, {
            user: param.user,
            sharedView: _extends({}, view, param.sharedView),
            oldSharedView: _extends({}, view),
            view,
            req: param.req,
            context
        });
        return result;
    }
    async shareViewDelete(context, param) {
        const view = await _models.View.get(context, param.viewId);
        if (!view) {
            _catchError.NcError.get(context).viewNotFound(param.viewId);
        }
        await _models.View.sharedViewDelete(context, param.viewId);
        this.appHooksService.emit(_nocodbsdk.AppEvents.SHARED_VIEW_DELETE, {
            user: param.user,
            view,
            req: param.req,
            context
        });
        return true;
    }
    async showAllColumns(context, param, ncMeta) {
        let viewWebhookManager;
        if (!param.viewWebhookManager) {
            var _param_viewWebhookManager;
            const view = await _models.View.get(context, param.viewId, ncMeta);
            viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(view.id)).forUpdate();
        }
        await _models.View.showAllColumns(context, param.viewId, param.ignoreIds || [], undefined, param.levelId);
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'view_column_refresh',
                payload: {
                    fk_view_id: param.viewId
                }
            }
        }, context.socket_id);
        if (viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(viewWebhookManager.getViewId())).emit();
        }
        return true;
    }
    async hideAllColumns(context, param, ncMeta) {
        let viewWebhookManager;
        if (!param.viewWebhookManager) {
            var _param_viewWebhookManager;
            const view = await _models.View.get(context, param.viewId, ncMeta);
            viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(view.id)).forUpdate();
        }
        await _models.View.hideAllColumns(context, param.viewId, param.ignoreIds || [], ncMeta, param.levelId);
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'view_column_refresh',
                payload: {
                    fk_view_id: param.viewId
                }
            }
        }, context.socket_id);
        if (viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(viewWebhookManager.getViewId())).emit();
        }
        return true;
    }
    async shareViewList(context, param) {
        return await _models.View.shareViewList(context, param.tableId);
    }
    constructor(appHooksService){
        this.appHooksService = appHooksService;
    }
};
ViewsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], ViewsService);
